import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import FormData from "form-data";
import {
  getCategoryProduct,
  getSubCategoriesList,
} from "./../redux/actions/action-creator";

import Preloader from "../helper/Preloader";
import Header from "../components/Header";
import ShoppingBreadcrumb from "../components/ShoppingBreadcrumb";
import ShopSection from "../components/ShopSection";
import ShippingTwo from "../components/ShippingTwo";
import Footer from "../components/Footer";
import BottomFooter from "../components/BottomFooter";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import { LOCATION_STORAGE_KEY } from "../utils/locationDefaults";

const EMPTY_ROUTE_STATE = {};
const EMPTY_ITEM = {};

const getValue = (item, keys) => {
  const matchedKey = keys.find(
    (key) => item?.[key] !== null && item?.[key] !== undefined && item?.[key] !== ""
  );

  return matchedKey ? item[matchedKey] : "";
};

const getIdFromSlug = (slug) => {
  const matchedId = String(slug || "").match(/(\d+)$/);
  return matchedId ? matchedId[1] : "";
};

const buildFormData = (payload) => {
  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      formData.append(key, value);
    }
  });

  return formData;
};

const getResponseItems = (response) => {
  const data = response?.data;
  const candidates = [
    data?.cell_contents,
    data?.response_data?.[0]?.cell_contents,
    data?.response_data,
    data?.data,
    data?.sub_categories,
    data?.subcategories,
    data,
  ];

  return candidates.find(Array.isArray) || [];
};

const getSubCategoryId = (item) =>
  getValue(item, [
    "sub_category_id",
    "subcategory_id",
    "subCategoryId",
    "category_id",
    "categoryId",
    "product_category_id",
    "id",
  ]);

const hasValue = (value) => value !== null && value !== undefined && value !== "";

const getSavedUserLocation = () => {
  try {
    const savedLocation = localStorage.getItem(LOCATION_STORAGE_KEY);
    return savedLocation ? JSON.parse(savedLocation) : null;
  } catch (error) {
    return null;
  }
};

const ShopPage = () => {
  const dispatch = useDispatch();
  const { storeSlug, categorySlug } = useParams();
  const routeLocation = useLocation();
  const routeState = routeLocation.state || EMPTY_ROUTE_STATE;
  const selectedCategory = routeState.category || EMPTY_ITEM;
  const selectedStore = routeState.store || EMPTY_ITEM;
  const {
    latitude,
    longitude,
    user_location,
    country_id,
    area,
  } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const [subCategoriesLoading, setSubCategoriesLoading] = useState(true);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryProduct, setCategoryProduct] = useState(null);
  const [error, setError] = useState("");
  // const [recentlybrowse, setRecentlybrowse] = useState([]);
  // const [brands, setBrands] = useState([]);

  const getActiveUserLocation = useCallback(() => {
    const savedLocation = getSavedUserLocation();
    const reduxLocation = user_location || {};

    return {
      latitude: latitude ?? reduxLocation?.latitude ?? savedLocation?.latitude,
      longitude: longitude ?? reduxLocation?.longitude ?? savedLocation?.longitude,
      country_id:
        country_id ??
        reduxLocation?.country_id ??
        reduxLocation?.countryId ??
        savedLocation?.country_id ??
        savedLocation?.countryId,
      area:
        area ??
        reduxLocation?.area ??
        reduxLocation?.area_id ??
        savedLocation?.area ??
        savedLocation?.area_id,
    };
  }, [area, country_id, latitude, longitude, user_location]);

  const getShopContext = useCallback(() => {
    const userLocation = getActiveUserLocation();
    const businessSegmentId =
      routeState.businessSegmentId ||
      getValue(selectedStore, ["business_segment_id", "businessSegmentId", "store_id", "storeId", "id"]) ||
      getValue(selectedCategory, ["business_segment_id", "businessSegmentId"]) ||
      getIdFromSlug(storeSlug);
    const selectedSegmentId =
      routeState.segmentId ||
      getValue(selectedCategory, ["segment_id", "segmentId", "segment"]) ||
      getValue(selectedStore, ["segment_id", "segmentId", "segment"]);
    const selectedCategoryId =
      routeState.parentCategoryId ||
      routeState.categoryId ||
      getValue(selectedCategory, ["category_id", "categoryId", "id", "product_category_id"]) ||
      getIdFromSlug(categorySlug || storeSlug) ||
      0;

    return {
      userLocation,
      businessSegmentId,
      selectedSegmentId,
      selectedCategoryId,
    };
  }, [
    categorySlug,
    getActiveUserLocation,
    routeState.businessSegmentId,
    routeState.categoryId,
    routeState.parentCategoryId,
    routeState.segmentId,
    selectedCategory,
    selectedStore,
    storeSlug,
  ]);

  const loadCategoryProduct = useCallback(
    async (shopContext, categoryId, page = 1) => {
      setError("");
      setLoading(true);
      setCurrentPage(page);

      const {
        userLocation,
        businessSegmentId,
        selectedSegmentId,
        selectedCategoryId,
      } = shopContext;

      const categoryProductPayload = {
        business_segment_id: businessSegmentId,
        segment_id: selectedSegmentId,
        category_id: hasValue(categoryId) ? categoryId : selectedCategoryId,
        parent_category_id: selectedCategoryId,
        page,
      };

    if (userLocation.latitude) categoryProductPayload.latitude = userLocation.latitude;
    if (userLocation.longitude) categoryProductPayload.longitude = userLocation.longitude;
    if (userLocation.country_id) categoryProductPayload.country_id = userLocation.country_id;
    if (userLocation.area) categoryProductPayload.area = userLocation.area;

    let categoryProductForm = buildFormData(categoryProductPayload);
    console.log("ShopPage getCategoryProduct Payload", categoryProductPayload);

    // /*RECENT BROWSE DATA*/
    // let recentProductData = new FormData();
    // recentProductData.append("segment_id", 10);
    // recentProductData.append("latitude", 25.3052099);
    // recentProductData.append("longitude", 55.4514529);
    // recentProductData.append("business_segment_id", 87);

    // /*BRAND DATA*/
    // let brandData = new FormData();
    // brandData.append("business_segment_id", 110);
    // brandData.append("segment_id", 4);
    // brandData.append("merchant_id", 1);
    // brandData.append("calling_from", "category_screen");
    // brandData.append("page", 1);
    // brandData.append("per_page", 10);

      try {
        const response = await dispatch(getCategoryProduct(categoryProductForm));

	    if (response.result) {
	      console.log("categoryProductForm", response)
	      setCategoryProduct(response);


      // // SECOND & THIRD API PARALLEL
      // const [recentlybrowseRes, brandsRes] = await Promise.all([
      //  dispatch(getRecentlyBrowseProduct(recentProductData)),
      //  dispatch(getStoreBrands(brandData))
      // ]);

      // if (recentlybrowseRes?.result) {
      //   console.log("RECENTLY BROWSE DATA", recentlybrowseRes);
      //   //setRecentlybrowse(recentlybrowseData);
      // }
      // if (brandsRes?.result) {
      //   console.log("BRANDS DATA RESPONSE", brandsRes);
      //   setBrands(brandsRes?.data?.response_data[0]);
      // }
        }
      } catch (error) {
        setCategoryProduct(null);
        setError(error?.message || "Products load nahi ho paye.");
        console.log("Category Product API Error:", error.message);
      } finally {
        setLoading(false);
      }
    },
    [dispatch]
  );

  const handleonload = useCallback(async () => {
    const shopContext = getShopContext();
    const {
      businessSegmentId,
      selectedSegmentId,
      selectedCategoryId,
    } = shopContext;

	  try {
	    setError("");
      setCategoryProduct(null);
      setSubCategories([]);
      setSelectedSubCategoryId("");
      setCurrentPage(1);
      setSubCategoriesLoading(true);
	    setLoading(true);

      const subCategoryPayload = {
        business_segment_id: businessSegmentId,
        category_id: selectedCategoryId,
        segment_id: selectedSegmentId,
      };
      const subCategoryForm = buildFormData(subCategoryPayload);

      console.log("ShopPage getSubCategoriesList Payload", subCategoryPayload);
      const subCategoryResponse = await dispatch(getSubCategoriesList(subCategoryForm));
      const subCategoryItems = getResponseItems(subCategoryResponse);

      setSubCategories(subCategoryItems);
      setSelectedSubCategoryId("0");
      setSubCategoriesLoading(false);

      await loadCategoryProduct(shopContext, 0, 1);
    } catch (error) {
      console.log("Sub Category API Error:", error?.message);
      setSubCategories([]);
      setSelectedSubCategoryId("0");
      setSubCategoriesLoading(false);

      await loadCategoryProduct(shopContext, 0, 1);
    }
}, [
  dispatch,
  getShopContext,
  loadCategoryProduct,
]);

const handleSubCategorySelect = useCallback(
  async (subCategory) => {
    const shopContext = getShopContext();
    const subCategoryId = getSubCategoryId(subCategory);

    if (!hasValue(subCategoryId)) return;

    setSelectedSubCategoryId(String(subCategoryId));
    await loadCategoryProduct(shopContext, subCategoryId, 1);
  },
  [getShopContext, loadCategoryProduct]
);

const handlePageChange = useCallback(
  async (page) => {
    const nextPage = Number(page);

    if (!Number.isFinite(nextPage) || nextPage < 1 || nextPage === currentPage) {
      return;
    }

    const shopContext = getShopContext();
    const categoryId = hasValue(selectedSubCategoryId) ? selectedSubCategoryId : 0;

    await loadCategoryProduct(shopContext, categoryId, nextPage);
  },
  [currentPage, getShopContext, loadCategoryProduct, selectedSubCategoryId]
);

useEffect(() => {
   handleonload();
}, [handleonload]);

const cartContext = getShopContext();

  return (
    <div className="bg-white">

      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* Header */}
      <Header category={true} />

      {/* Breadcrumb */}
      <ShoppingBreadcrumb page="shop" store={selectedStore} businessSegmentId={cartContext.businessSegmentId} segmentId={cartContext.selectedSegmentId} />

      {/* ShopSection */}
	    <ShopSection
        categoryProduct={categoryProduct}
        loading={loading}
        error={error}
        subCategories={subCategories}
        subCategoriesLoading={subCategoriesLoading}
        selectedSubCategoryId={selectedSubCategoryId}
        onSubCategorySelect={handleSubCategorySelect}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        productDetailContext={{ ...routeState, storeSlug, categorySlug, parentCategoryId: cartContext.selectedCategoryId }}
        cartContext={{
          segment_id: cartContext.selectedSegmentId,
          business_segment_id: cartContext.businessSegmentId,
        }}
      />

      {/* ShippingTwo */}
      <ShippingTwo />

      {/* Footer */}
      <Footer />

      {/* BottomFooter */}
      <BottomFooter />

    </div>
  );
};

export default ShopPage;
